import {
  Id,
  ReadByCountsData,
  MessagesResponse as Response,
} from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from 'chat/shared/queries/keys'

export function useReadByCounts(converastionId: Id, enabled = false) {
  const { server } = useServer()

  return useQuery<ReadByCountsData>({
    queryKey: keys.readByCounts(converastionId),
    queryFn: fetchReadByCounts,
    refetchOnMount: true,
    enabled: enabled,
  })

  async function fetchReadByCounts() {
    const response = await server.get<Response.ReadByCounts>(
      `/v2/chat/conversations/${converastionId}/read_by_counts`
    )
    return response
  }
}
